import { useRouterNavigation } from '~/router.ts'

export function isInternalLink(
  href: string | undefined
): href is string {
  return !!href && href.startsWith('/')
}

export function useOnClickHrefRouter<
  OnClick extends (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => void
>(href: string, onClick?: OnClick) {
  const { push } = useRouterNavigation()
  if (onClick) return onClick
  return function (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) {
    if (isInternalLink(href)) {
      e.preventDefault()
      return push(href!)
    }
  }
}
